// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zfR-","label":"styles_label__3CyS0"};